import apiService from './apiService'

// Service pour les données du dashboard
export async function getDashboardData() {
  try {
    const response = await apiService.get('/dashboard')
    return response.data
  } catch (error) {
    console.error('Error fetching dashboard data:', error)
    throw error
  }
}

// Obtenir les statistiques détaillées
export async function getDashboardStats() {
  try {
    const response = await apiService.get('/dashboard/stats')
    return response.data
  } catch (error) {
    console.error('Error fetching dashboard stats:', error)
    throw error
  }
}

// Obtenir les échéances à venir
export async function getUpcomingEcheances() {
  try {
    const response = await apiService.get('/dashboard/echeances')
    return response.data
  } catch (error) {
    console.error('Error fetching upcoming echeances:', error)
    throw error
  }
}

// Obtenir les factures récentes
export async function getRecentFactures() {
  try {
    const response = await apiService.get('/dashboard/factures-recentes')
    return response.data
  } catch (error) {
    console.error('Error fetching recent factures:', error)
    throw error
  }
}

// Obtenir les contrats expirant bientôt
export async function getExpiringContrats() {
  try {
    const response = await apiService.get('/dashboard/contrats-expirants')
    return response.data
  } catch (error) {
    console.error('Error fetching expiring contrats:', error)
    throw error
  }
}

// Obtenir les alertes
export async function getAlertes() {
  try {
    const response = await apiService.get('/dashboard/alertes')
    return response.data
  } catch (error) {
    console.error('Error fetching alertes:', error)
    throw error
  }
}

// Obtenir les revenus par mois
export async function getRevenusMensuels() {
  try {
    const response = await apiService.get('/dashboard/revenus-mensuels')
    return response.data
  } catch (error) {
    console.error('Error fetching revenus mensuels:', error)
    throw error
  }
}

// Obtenir les statistiques par type de bien
export async function getStatsByTypeBien() {
  try {
    const response = await apiService.get('/dashboard/stats-type-bien')
    return response.data
  } catch (error) {
    console.error('Error fetching stats by type bien:', error)
    throw error
  }
} 



